<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="">
    <v-btn v-if="order.status >= OrderConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO &&
                       order.cache_do_qty > 0 && item.cache_do_qty!=null && item.quantity - item.cache_do_qty>0"
           :color="OrderConst.color(order.status)"
           class="ml-1 pa- caption"
           x-small>
      ค้างจัดทริป {{ number_format(item.quantity - item.cache_do_qty) }}
      {{ $helper.parseUnit(item.unit) }}
    </v-btn>
    <v-btn v-if="order.status >= OrderConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO &&
                       order.cache_do_qty > 0 && item.cache_do_qty!=null && item.cache_do_qty - item.quantity>0"
           :color="OrderConst.color(order.status)"
           class="ml-1 pa- caption"
           x-small>
      จัดทริปเกิน {{ $helper.number_format(item.cache_do_qty - item.quantity) }}
      {{ $helper.parseUnit(item.unit) }}
    </v-btn>


    <v-btn v-if="order.status >= OrderConst.STATUS_DO_CONFIRMED_WAIT_STOCK &&
                       order.cache_s_qty > 0 && item.cache_s_qty!=null && item.quantity - item.cache_s_qty>0"
           :color="OrderConst.color(order.status)"
           class="ml-1 pa-1 caption"
           x-small>
      ค้างคลังอนุมัติ {{ $helper.number_format(item.quantity - item.cache_s_qty) }}
      {{ $helper.parseUnit(item.unit) }}
    </v-btn>

    <v-btn v-if="order.status >= OrderConst.STATUS_DO_CONFIRMED_WAIT_STOCK &&
                       order.cache_s_qty > 0  && item.cache_s_qty!=null && item.cache_s_qty - item.quantity>0"
           :color="OrderConst.color(order.status)"
           class="ml-1 pa-1 caption"
           x-small>
      คลังอนุมัติเกิน {{ $helper.number_format(item.cache_s_qty - item.quantity) }}
      {{ $helper.parseUnit(item.unit) }}
    </v-btn>
    <v-btn v-if="order.status>=OrderConst.STATUS_DELIVERY_SUCCESS &&
                       order.cache_inv_qty > 0 && item.cache_inv_qty!=null && item.quantity - item.cache_inv_qty>0"
           :color="OrderConst.color(order.status)"
           class="ml-1 pa-1 caption"
           x-small>
      ค้างแจ้งหนี้ {{ $helper.number_format(item.quantity - item.cache_inv_qty) }}
      {{ $helper.parseUnit(item.unit) }}
    </v-btn>
    <v-btn v-if="order.status>=OrderConst.STATUS_DELIVERY_SUCCESS &&
                       order.cache_inv_qty > 0 && item.cache_inv_qty!=null && item.cache_inv_qty - item.quantity >0"
           :color="OrderConst.color(order.status)"
           class="ml-1 pa-1 caption"
           x-small>
      แจ้งหนี้เกิน {{ $helper.number_format(item.cache_inv_qty - item.quantity) }}
      {{ $helper.parseUnit(item.unit) }}
    </v-btn>
  </div>

</template>
<style lang="scss" scoped>


</style>

<script lang="ts">

import {Component, Prop, Vue} from 'vue-property-decorator'
import {Order, OrderConst} from '../../models/Order'
import {Item} from '../../models/Item'
import Helper from '../../services/Helper.js'

@Component({
  components: {},
})
export default class StatusBadge extends Vue {
  @Prop() order: Order
  @Prop() item: Item

  OrderConst = OrderConst

  number_format = this.$helper.number_format
}

</script>
